import { render, staticRenderFns } from "./singPassLogin.vue?vue&type=template&id=670c17d2&scoped=true&"
import script from "./singPassLogin.vue?vue&type=script&lang=js&"
export * from "./singPassLogin.vue?vue&type=script&lang=js&"
import style0 from "./singPassLogin.vue?vue&type=style&index=0&id=670c17d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c17d2",
  null
  
)

export default component.exports